<template>
  <div>
    <div v-if="form" style="text-align: right;" dir="rtl">
      <div>
        <p class="bold">Title</p>
        <input class="outlined full_width" :class="{ error_field: form.data.huji_position.fields.title.has_error }" placeholder='לדוגמא... יועמ"ש לחברת בינלאומית - M&A'
               @focus="form.data.huji_position.fields.title.has_error=false;"
               v-model="form.data.huji_position.fields.title.value">
      </div>
      <div>
        <p class="bold">Content</p>
        <textarea v-model="form.data.huji_position.fields.content.value" :class="{ error_field: form.data.huji_position.fields.content.has_error }"
                  @focus="form.data.huji_position.fields.content.has_error=false;"
                  class="full_width content"></textarea>
      </div>
      <div>
        <p class="bold">Position Applicant Code</p>
        <input dir="ltr" class="outlined" v-model="form.data.huji_position.fields.position_applicant_code.value" placeholder="לדוגמא... S-2910436"
              :class="{ error_field: form.data.huji_position.fields.position_applicant_code.has_error }"
              @focus="form.data.huji_position.fields.position_applicant_code.has_error=false;">
      </div>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  props: ['payload'],
  name: 'admin-huji-position-form',
  data () {
    return {
      is_loading: false,
      form: undefined
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      if (this.payload.is_create) {
        this.setForm({
          id: ''
        })
        return
      }
      this.$network_utils.getHujiPosition({ id: this.payload.data.id }).then(response => {
        this.setForm(response)
      })
    },
    setForm (form_data) {
      this.form = new this.$form({
        huji_position: {
          fields: {
            title: {
              value: form_data.title,
              has_error: false,
              validations: ['Exists']
            },
            content: {
              value: form_data.content,
              has_error: false,
              validations: ['Exists']
            },
            position_applicant_code: {
              value: form_data.position_applicant_code,
              has_error: false,
              validations: ['Exists']
            },
            id: {
              value: form_data.id,
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: this.payload.is_create ? 'post' : 'put',
            url: '/huji_positions/' + form_data.id,
            headers: 'admin_headers'
          },
          is_used: true
        }
      })
    },
    submit () {
      let position_applicant_code = this.form.data.huji_position.fields.position_applicant_code.value
      if (position_applicant_code == undefined || !position_applicant_code.startsWith('S-')) {
        this.$utils.emit('show_toast', { text: 'Position Applicant Code אמור להתחיל עם "-S"' })
        return
      }
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      this.is_loading = true
      response.promise.then((response) => {
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'success' })
        this.remove(this.payload)
      })
    },
    ...mapMutations('modals', ['remove'])
  }
}
</script>
<style scoped>
  .content{
    height: 300px;
  }
</style>
